import React from 'react';
import CustomFilterSelect from '../../designSystem/CustomFilterSelect';
import './customPagination.css';

const ItemsPerPageSelector = ({ value, onChange }) => {
  const itemsPerPageOptions = [
    { id: 10, name: '10' },
    { id: 30, name: '30' },
    { id: 50, name: '50' },
    { id: 80, name: '80' },
    { id: 100, name: '100' }
  ];

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <CustomFilterSelect
      label="Page Size"
      value={value || 10}
      onChange={handleChange}
      options={itemsPerPageOptions}
      searchable={false}
      width="100px"
    />
  );
};

export default ItemsPerPageSelector;